import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import LanguageSelector from './LanguageSelector';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/i18n';
import { authUrl } from '../utils/apiUrl';
import './PublicPageLayout.css';

/**
 * Shared chrome for public pages (all-news, groq-tutorial, blog post).
 * @param {{ title?: string, subtitle?: string, backTo?: string, backLabel?: string, children: React.ReactNode, showAppLink?: boolean, hideHeader?: boolean }} props
 */
function PublicPageLayout({
  title,
  subtitle,
  backTo = '/',
  backLabel,
  children,
  showAppLink = true,
  hideHeader = false,
}) {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(authUrl('/auth/me'), { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => { if (!cancelled) setUser(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const resolvedBackLabel = backLabel || t('publicLayout.backToHome', language);

  return (
    <div className="public-page-layout">
      <div className="public-page-topbar">
        <Link to="/" className="public-page-brand">
          MisKosas
        </Link>
        <div className="d-flex align-items-center gap-2">
          {showAppLink && user && (
            <Link to="/app" className="btn btn-sm btn-light public-page-app-link">
              {t('publicLayout.goToApp', language)}
            </Link>
          )}
          <LanguageSelector />
        </div>
      </div>

      {!hideHeader && (
        <header className="miskosas-page-header">
          <Container>
            <button
              type="button"
              className="btn btn-link public-page-back text-white text-decoration-none p-0 mb-2"
              onClick={() => navigate(backTo)}
            >
              ← {resolvedBackLabel}
            </button>
            {title ? <h1>{title}</h1> : null}
            {subtitle ? <p>{subtitle}</p> : null}
          </Container>
        </header>
      )}

      <main className="public-page-main">
        <Container>{children}</Container>
      </main>

      <footer className="landing-footer py-4 text-center">
        <Container>
          <p className="mb-2 public-footer-text">{t('landing.footerText', language)}</p>
          <p className="mb-0 public-footer-copy">{t('landing.footerCopyright', language)}</p>
        </Container>
      </footer>
    </div>
  );
}

export default PublicPageLayout;
